export default __webpack_public_path__ + "static/media/verification.ca281bc6.png";